import { Pre } from "./Pre";

export function JsonField({ value }: { value: unknown }) {
  return <Pre>{JSON.stringify(value, null, 2)}</Pre>;
}
